<template>
  <div class="content" v-if="rendered">
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <simple-wizard>
          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              <i class="tim-icons  icon-chat-33"></i>
              <!-- <i class="tim-icons  icon-bell-55"></i> -->
              <p>Notificação</p>
            </template>
            <div class="row justify-content-left pr-3 pl-3">
              <div class="col-sm-12 text-left">
                <h4>
                  Notificação:
                </h4>
                <p>Max 120 caracteres</p>
                <p>Min 40 caracteres</p>
                <textarea
                  v-model="notificacao"
                  class="text-area form-control"
                  rows="6"
                  placeholder="Notificação"
                  maxlength="120"
                ></textarea>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              <i class="tim-icons icon-single-02"></i>
              <p>Segmentar</p>
            </template>
            <div class="row justify-content-left pr-3 pl-3">
              <div class="col-sm-12 text-left">
                <h4>
                  Enviar para quem?
                </h4>
              </div>
            </div>
            <div class="row justify-content-left mt-3 pr-3 pl-3">
              <div class="col-sm-6 text-left">
                <h4>
                  <base-button
                    native-type="submit"
                    type="primary"
                    class="botaoEnviarNotificacoes"
                    :class="notificacaoTodos ? 'ativo' : ''"
                    size="md"
                    block
                    @click="interacaoBotaoSegmentar('todos')"
                  >
                    Enviar para todos
                  </base-button>
                </h4>
              </div>
              <div class="col-sm-6 text-left">
                <h4>
                  <base-button
                    native-type="submit"
                    type=""
                    class="botaoEnviarNotificacoes"
                    :class="notificacaoFiltro ? 'ativo' : ''"
                    size="md"
                    block
                    @click="interacaoBotaoSegmentar('filtro')"
                  >
                    Filtrar envio
                  </base-button>
                </h4>
              </div>
            </div>
            <div
              class="row justify-content-left mt-3 pr-3 pl-3"
              v-if="notificacaoFiltro"
            >
              <div class="col-lg-6 col-md-6 text-left filtragem">
                <h4>Produtos</h4>
                <el-select
                  multiple
                  class="select-info"
                  size="large"
                  v-model="produtoSelected"
                  placeholder="Produtos"
                  @change="produtoAlterado"
                  multiple-limit="3"
                >
                  <el-option
                    v-for="option in produtos"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-lg-6 col-md-6 text-left filtragem">
                <h4>Sexo</h4>
                <el-select
                  class="select-info"
                  size="large"
                  v-model="sexoSelected"
                  placeholder="Templates"
                  @change="templateAlterado"
                >
                  <el-option class="select-info" value="" label="Todos">
                  </el-option>
                  <el-option
                    v-for="option in sexos"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-lg-12 text-left mt-3">
                <div class="row">
                  <h4>
                    Ticket Médio
                  </h4>
                  <div class="col-sm-6">
                    <p>
                      De
                    </p>
                    <base-input
                      name="notificacao"
                      v-model="ticketMedio.inicio"
                      type="textarea"
                      placeholder="Notificação"
                    ></base-input>
                  </div>
                  <div class="col-sm-6">
                    <p>
                      a
                    </p>
                    <base-input
                      name="notificacao"
                      v-model="ticketMedio.fim"
                      type="textarea"
                      placeholder="Notificação"
                    ></base-input>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 text-left mt-3">
                <div class="row">
                  <h4>
                    Faturação
                  </h4>
                  <div class="col-sm-6">
                    <p>
                      De
                    </p>
                    <base-input
                      name="notificacao"
                      v-model="faturacao.inicio"
                      type="textarea"
                      placeholder="Notificação"
                    ></base-input>
                  </div>
                  <div class="col-sm-6">
                    <p>
                      a
                    </p>
                    <base-input
                      name="notificacao"
                      v-model="faturacao.fim"
                      type="textarea"
                      placeholder="Notificação"
                    ></base-input>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 text-left mt-3">
                <div class="row">
                  <h4>
                    Número de Visitas
                  </h4>
                  <div class="col-sm-6">
                    <p>
                      De
                    </p>
                    <base-input
                      name="notificacao"
                      v-model="numeroVisitas.inicio"
                      type="textarea"
                      placeholder="Notificação"
                    ></base-input>
                  </div>
                  <div class="col-sm-6">
                    <p>
                      a
                    </p>
                    <base-input
                      name="notificacao"
                      v-model="numeroVisitas.fim"
                      type="textarea"
                      placeholder="Notificação"
                    ></base-input>
                  </div>
                </div>
              </div>
            </div>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step3')">
            <template slot="label">
              <i class="tim-icons icon-email-85"></i>
              <p>Resumo</p>
            </template>
            <div class="row justify-content-left pr-3 pl-3">
              <div class="col-sm-12 text-left">
                <div class="row">
                  <div class="col-lg-12">
                    <h4>
                      Enviar para
                      <span style="color: red; font-weight: bold;">{{
                        arrayFiltrada.length
                      }}</span>
                      pessoas.
                    </h4>
                    <h4>Notificação:</h4>
                    <p>{{ notificacao }}</p>
                  </div>
                </div>
                <p></p>
                <el-table :data="filteredFilters">
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Nome"
                    property="nome"
                  ></el-table-column>
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Telefone"
                    property="telefone"
                  ></el-table-column>
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Nif"
                    property="nif"
                  ></el-table-column>
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Email"
                    property="email"
                  ></el-table-column>
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Faturação Total (€)"
                    property="faturacao_total"
                  ></el-table-column>
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Ticket Médio (€)"
                    property="ticket_medio"
                  ></el-table-column>
                  <el-table-column
                    min-width="150"
                    sortable
                    label="Número de Visitas"
                    property="numero_visitas"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Select, Option } from "element-ui";
import api from "../api/index";
import { Modal, BaseInput, Card } from "@/components/index";
import { SimpleWizard, WizardTab } from "@/components";
import FirstStep from "./Forms/Wizard/FirstStep.vue";
import SecondStep from "./Forms/Wizard/SecondStep.vue";
import ThirdStep from "./Forms/Wizard/ThirdStep.vue";
export default {
  components: {
    Modal,
    Card,
    BaseInput,
    [Option.name]: Option,
    [Select.name]: Select,
    SimpleWizard,
    WizardTab,
    FirstStep,
    SecondStep,
    ThirdStep,
  },
  data() {
    return {
      rendered: false,
      events: [],
      modals: {
        classic: false,
      },
      ticketMedio: {
        inicio: 0,
        fim: 0,
      },
      faturacao: {
        inicio: 0,
        fim: 0,
      },
      numeroVisitas: {
        inicio: 0,
        fim: 0,
      },
      notificacao: "",
      valor: "",
      consumo: [],
      sexos: [
        {
          label: "Masculino",
          value: "Masculino",
        },
        {
          label: "Feminino",
          value: "Feminino",
        },
        {
          label: "Outros",
          value: "Outros",
        },
      ],
      restaurantes: [],
      produtos: [],
      filtrar: false,
      clientes: [],
      produtoSelected: "",
      sexoSelected: "",
      admin: "0",
      periodo_meses: 6,
      todosCartoes: [],
      passo2Validado: false,
      notificacaoFiltro: false,
      notificacaoTodos: false,
      arrayFinal: [],
      arrayFiltrada: ["teste"],
    };
  },
  methods: {
    interacaoBotaoSegmentar(valor) {
      if (valor == "todos") {
        this.notificacaoFiltro = false;
        if (this.passo2Validado) {
          this.passo2Validado = false;
          this.notificacaoTodos = false;
        } else {
          this.passo2Validado = true;
          this.notificacaoTodos = true;
        }
        return;
      }
      if (valor == "filtro") {
        this.passo2Validado = false;
        this.notificacaoTodos = false;
        if (this.notificacaoFiltro) {
          this.passo2Validado = false;
          this.notificacaoFiltro = false;
        } else {
          this.passo2Validado = true;
          this.notificacaoFiltro = true;
        }
        return;
      }
    },
    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },
    produtoAlterado() {
      console.log(this.produtoSelected);
    },
    async validateStep(ref) {
      if (ref == "step1") {
        if (this.notificacao.length < 40 || this.notificacao.length > 120) {
          this.notifyVue(
            "top",
            "right",
            "warning",
            "A notificação tem de ter entre 40 a 120 caracteres"
          );
          return;
        }
        this.$emit("on-validated", true);
        return true;
      }
      if (ref == "step2") {
        if (!this.passo2Validado) {
          return;
        }
        if (this.notificacaoFiltro) {
          const temp = this.arrayFinal;
          const filteredResults = Object.values(temp).filter((item) => {
            const {
              numero_visitas,
              ticket_medio,
              faturacao_total,
              produtos_comprados,
              sexo,
            } = item;

            const sexoValido =
              this.sexoSelected !== "" ? this.sexoSelected === sexo : true;

            const ticketMedioValido =
              this.ticketMedio.inicio > 0 || this.ticketMedio.fim > 0
                ? this.ticketMedio.inicio <= ticket_medio &&
                  ticket_medio <= this.ticketMedio.fim
                : true;

            const numeroVisitasValido =
              this.numeroVisitas.inicio > 0 || this.numeroVisitas.fim > 0
                ? this.numeroVisitas.inicio <= numero_visitas &&
                  numero_visitas <= this.numeroVisitas.fim
                : true;

            const faturacaoValida =
              this.faturacao.inicio > 0 || this.faturacao.fim > 0
                ? this.faturacao.inicio <= faturacao_total &&
                  faturacao_total <= this.faturacao.fim
                : true;

            const produtosValidos =
              this.produtoSelected.length > 0
                ? produtos_comprados.some((produto) =>
                    this.produtoSelected.includes(produto.produto)
                  )
                : true;

            return (
              ticketMedioValido &&
              numeroVisitasValido &&
              faturacaoValida &&
              produtosValidos &&
              sexoValido
            );
          });
          this.arrayFiltrada = filteredResults;

          if (this.arrayFiltrada.length == 0) {
            this.notifyVue(
              "top",
              "right",
              "warning",
              "Nenhum contacto encontrado com estes filtros."
            );
            return;
          }
        } else {
          this.arrayFiltrada = Object.values(this.arrayFinal);
        }
        this.$emit("on-validated", true);
        return true;
      }
      if (ref == "step3") {
        this.rendered = false;
        var ids = [];
        var temp = this.arrayFiltrada;
        for (let i = 0; i < temp.length; i++) {
          if (temp[i].passId) {
            ids.push(temp[i].passId);
          }
        }
        let json = {
          passIDs: ids,
          mensagem: this.notificacao,
        };

        let res = await api.enviarNotificacoes(json);
        this.inicio();
        setTimeout(() => {
          this.notifyVue(
            "top",
            "right",
            "success",
            ids.length + " notificações enviadas"
          );
        }, 1500);
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    async inicio() {
      this.rendered = false;

      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      var resUser1 = await api.listarRestaurantes();
      if (!localStorage.getItem("gerenciaRestauranteAtivo")) {
        localStorage.setItem(
          "gerenciaRestauranteAtivo",
          resUser1.resultado[0].nome
        );
      }
      let resUser = await api.listarRestaurante({
        nome: resUser1.resultado[0].nome,
      });
      this.admin = resUser.resultado.admin == "1" ? true : false;
      var json = {
        restaurante: user.nome,
        admin: resUser.resultado.admin,
      };
      this.restaurante = localStorage.getItem("gerenciaRestauranteAtivo");
      var periodo_meses = 0;
      if (!localStorage.getItem("gerenciaPeriodoMeses")) {
        periodo_meses = this.periodo_meses;
        localStorage.setItem("gerenciaPeriodoMeses", periodo_meses);
      } else {
        periodo_meses = localStorage.getItem("gerenciaPeriodoMeses");
      }
      // IR BUSCAR TODOS OS CARTÕES
      var resCartoes = await api.buscarTodosCartoesCriados();
      resCartoes = Object.values(resCartoes.resultado);
      this.todosCartoes = resCartoes;
      var resCartoesRestaurante = await api.buscarTodosCartoesCriados();
      resCartoesRestaurante = Object.values(resCartoesRestaurante.resultado);

      var jsonPeriodo = {
        restaurante: this.restaurante,
        periodo_meses: this.periodo_meses,
      };
      let consumo = await api.listarConsumo(jsonPeriodo);
      consumo = Object.values(consumo.resultado);
      this.consumo = consumo;
      let visitas = await api.listarVisitas(jsonPeriodo);
      visitas = visitas;

      const resultado = {};
      for (let key in visitas.detalheVisitas) {
        const visita = visitas.detalheVisitas[key];
        const qr_code = visita.qr_code;

        // Validação do NIF
        if (!qr_code || typeof qr_code !== "string") {
          continue;
        }

        const valor = parseFloat(visita.valor);

        if (!resultado[qr_code]) {
          resultado[qr_code] = {
            id: visita.id,
            restaurante: visita.restaurante,
            nif: visita.nif,
            numero_visitas: 0,
            ticket_medio: 0,
            faturacao_total: 0,
            produtos_comprados: [], // Adicionar um array para produtos e quantidades
          };
        }

        // Incrementa número de visitas e faturação total
        resultado[qr_code].numero_visitas++;
        resultado[qr_code].faturacao_total += valor;
        resultado[qr_code].ticket_medio = (
          resultado[qr_code].faturacao_total / resultado[qr_code].numero_visitas
        ).toFixed(2);

        // Função para adicionar produtos e incrementar quantidade se já existir
        const adicionarProduto = (produto, quantidade, categoria) => {
          const produtoExistente = resultado[qr_code].produtos_comprados.find(
            (item) => item.produto === produto
          );

          if (produtoExistente) {
            // Incrementa a quantidade do produto existente
            produtoExistente.quantidade += parseInt(quantidade);
          } else {
            // Adiciona novo produto ao array
            resultado[qr_code].produtos_comprados.push({
              produto: produto,
              quantidade: parseInt(quantidade),
              categoria: categoria || visita.categoria, // Categoria pode vir de visita ou consumo
            });
          }
        };

        // Adiciona o produto e quantidade da visita
        if (visita.produto && visita.quantidade) {
          adicionarProduto(visita.produto, visita.quantidade, visita.categoria);
        }

        // Adiciona passId, nome, telefone, email ao resultado se o NIF corresponder
        const usuario = this.todosCartoes.find(
          (user) => user.qr_code === qr_code
        );
        if (usuario) {
          resultado[qr_code].passId = usuario.passId;
          resultado[qr_code].nome = usuario.nome;
          resultado[qr_code].telefone = usuario.telefone;
          resultado[qr_code].email = usuario.email;
          resultado[qr_code].sexo = usuario.sexo;
          resultado[qr_code].data_nascimento = usuario.data_nascimento;
        }

        // Busca os produtos e quantidades na array this.consumo para o NIF
        const produtosConsumidos = this.consumo.filter(
          (consumo) => consumo.qr_code === qr_code
        );

        // Adiciona os produtos consumidos ao resultado, evitando duplicações
        produtosConsumidos.forEach((consumo) => {
          if (consumo.produto && consumo.quantidade) {
            adicionarProduto(
              consumo.produto,
              consumo.quantidade,
              consumo.categoria
            );
          }
        });
      }
      this.todosCartoes.forEach((usuario) => {
        const qr_code = usuario.qr_code;

        // Se o NIF não existe em resultado, adiciona com os valores padrão
        if (!resultado.hasOwnProperty(qr_code)) {
          resultado[qr_code] = {
            id: null, // Se não houver visita, id pode ser nulo ou não definido
            restaurante: null, // Também pode ser nulo, pois não há visita associada
            nif: usuario.nif,
            numero_visitas: 0,
            ticket_medio: 0,
            faturacao_total: 0,
            qr_code: qr_code,
            produtos_comprados: [],
            passId: usuario.passId,
            nome: usuario.nome,
            data_nascimento: usuario.data_nascimento,
            sexo: usuario.sexo,
            telefone: usuario.telefone,
            email: usuario.email,
          };
        }
      });
      this.arrayFinal = resultado;
      this.arrayFiltrada = [];

      const uniqueProducts = Array.from(
        new Map(
          this.consumo.map((item) => [
            item.produto,
            { value: item.produto, label: item.produto },
          ])
        ).values()
      );

      this.produtos = uniqueProducts.sort((a, b) =>
        a.label.localeCompare(b.label)
      );
      // Array de todos os produtos consumidos

      this.rendered = true;
    },
  },
  async mounted() {
    await this.inicio();
  },
  computed: {
    filteredFilters() {
      return this.arrayFiltrada;
    },
  },
};
</script>
<style>
#fullCalendar {
  min-height: 400px;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
